















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class VModal extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop() private show!: boolean;
}
